'use client'
import { useState } from 'react'
import Link from 'next/link'
import { useSearchParams, usePathname } from 'next/navigation'
import styles from './BrandNav.module.css'

export default function BrandNav({ headerStyle, brand, isActiveBrand, onActivate }) {
  const [visible, setVisible] = useState(false)
  const searchParams = useSearchParams()
  const pathname = usePathname()

  return (
    <li
      className="navigation__item"
      style={{ 
        position: 'relative'
      }}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      <span 
        className="navigation__link"
        style={{
          color: isActiveBrand
          ? headerStyle?.HeaderFontFocusColor
          : headerStyle?.HeaderFontColor,
        }}
      >品牌
      </span>

      <div
        className={`${styles.brandMenuContainer} ${
          visible ? styles.visible : ''
        }`}
      >
        <ul className={styles.brandMenuList}>
          {brand?.map((elm) => (
            <li key={elm.BrandID}>
              <Link
                href={`/product-list?brandid=${elm.BrandID}`}
                className={styles.brandMenuLink}
                onClick={() => {
                  setVisible(false) // 點擊後收起選單
                  onActivate()
                }}
              >
                {elm.BrandName}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </li>
  )
}
